import React, { useEffect, useRef, useState } from "react"
import { Checkbox as CoreCheckbox } from "@stardust-ds/react"

import styles from "./index.module.scss"
import Label from "../Label"
import InfoIcon from "../../../assets/icons/InfoIcon"

const oCheckboxSizes = {
  md: "",
  sm: styles.checkboxSm,
}

const oLabelSizes = {
  md: styles.labelMd,
  sm: styles.labelSm,
}

const RcmpCheckBox = React.forwardRef((props, ref) => {
  const {
    cLabel,
    cSize = "md",
    checked,
    onChange,
    bColorLabel,
    cdescription,
    HoverActionButton,
    bCanShowTooltip = false,
    className = "",
    isExportedField = false,
    boardModel = undefined,
    parentRef = null,
    ...oRest
  } = props
  const [bIsCollapsedText, fnSetBIsCollapsedText] = useState(true)
  const [isVisible, setIsVisible] = useState(false)
  const [toolTipIsVisible, setToolTipIsVisible] = useState(false)
  const tooltipRef = useRef(null)
  const spanRef = useRef(null)


  const handleMouseEnter = (e) => {
   
    if (cdescription || HoverActionButton || bCanShowTooltip) {
      setIsVisible(true)
    }
  }
  const handleMouseLeave = () => {
    setIsVisible(false)
  }

  const [bIsChecked, fnSetBIsChecked] = useState(checked)
  function fnHandleOnChange(e) {
    fnSetBIsChecked(e?.target?.checked)
    onChange?.(e)
  }
  useEffect(() => {
    fnSetBIsChecked(checked)
  }, [checked])

  useEffect(() => {
    if (toolTipIsVisible && parentRef.current && tooltipRef.current && spanRef.current) {
      const parentRect = parentRef.current.getBoundingClientRect()
      const tooltipRect = tooltipRef.current.getBoundingClientRect()

      if (tooltipRect.right > parentRect.width) {
        spanRef.current.style.right = "0"
        spanRef.current.style.left = "auto"
        return
      }
      spanRef.current.style.left = "0"
      spanRef.current.style.right = "auto"
      return
    }
  }, [toolTipIsVisible])

  const cCheckboxClass = oCheckboxSizes[cSize] || oCheckboxSizes.md
  const cLabelClass = oLabelSizes[cSize] || oLabelSizes.md

  return (
    <>
      <div
        className={`${styles.checkboxContainer} ${className}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <CoreCheckbox
          ref={ref}
          {...oRest}
          className={cCheckboxClass}
          activeColor="#6CB6E3"
          inactiveColor="#415364"
          checked={bIsChecked}
          onChange={fnHandleOnChange}
        />
        <Label
          className={`${styles.label} ${
            bColorLabel && bIsChecked ? styles.colorLabel : styles.label
          } ${cLabelClass}`}
        >
          {cLabel} 
        </Label>

      {isVisible && !toolTipIsVisible && (
          <div className={styles.tooltipDescription}>
            {HoverActionButton && <HoverActionButton />}
            <div onClick={() => {
              fnSetBIsCollapsedText(!bIsCollapsedText)
            }}>
            <p><strong>{cLabel.length > 15 && bIsCollapsedText ? cLabel.slice(0,15) + '...' : cLabel}</strong></p>
              {cdescription && (
                <p
                >
                  {cdescription.length > 15
                    ? cdescription.slice(0, 15) + "..."
                    : cdescription}
                  {/* descrição do campo */}
                </p>
              )}
            </div>
          </div>
        )}
        
        {isExportedField && boardModel && (
        <div
          ref={tooltipRef}
          className={styles.exportedTooltip}
          onMouseEnter={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setToolTipIsVisible(true)
          }}
          onMouseLeave={() => {
            setToolTipIsVisible(false)
          }}
        >
          <InfoIcon fill="#415364" />
          {toolTipIsVisible && <span ref={spanRef}>{boardModel.opbd_cname}</span>}
        </div>
      )}
      </div>

      
    </>
  )
})

export default RcmpCheckBox
